module.exports = __webpack_public_path__ + "static/media/informatyka.ce4fd6b8.png";